import { createSlice } from '@reduxjs/toolkit';

import {
    ARCHIVE_PROPOSAL,
    ARCHIVE_PROPOSAL_FAILURE,
    ARCHIVE_PROPOSAL_SUCCESS,
    DELETE_PROPOSAL,
    DELETE_PROPOSAL_FAILURE,
    DELETE_PROPOSAL_SUCCESS,
    FETCH_PROPOSALS,
    FETCH_PROPOSALS_FAILURE,
    FETCH_PROPOSALS_SUCCESS,
    OPEN_PROPOSAL_MODAL,
    RESET,
    SHOW_EMPTY_STATE,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    archiveProposal: {
        isLoading: false,
        errors: [],
    },
    proposals: {
        data: [],
        errors: [],
        isFetching: false,
    },
    createProposal: {
        isSaving: false,
        data: null,
        errors: [],
    },
    deleteProposal: {
        isDeleting: false,
        errors: [],
    },
    isOpenProposalModal: false,
    showEmptyState: {
        status: 'active',
        show: false,
    },
};

const proposalsSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [ARCHIVE_PROPOSAL]: (state) => {
            state.archiveProposal = {
                ...state.archiveProposal,
                errors: [],
                isLoading: true,
            };
        },
        [ARCHIVE_PROPOSAL_FAILURE]: (state, action) => {
            state.archiveProposal = {
                ...state.archiveProposal,
                errors: action.payload,
                isLoading: false,
            };
        },
        [ARCHIVE_PROPOSAL_SUCCESS]: (state, action) => {
            state.archiveProposal = {
                ...state.archiveProposal,
                data: action.payload,
                isLoading: false,
            };
        },
        [DELETE_PROPOSAL]: (state) => {
            state.deleteProposal = {
                ...state.deleteProposal,
                errors: [],
                isDeleting: true,
            };
        },
        [DELETE_PROPOSAL_FAILURE]: (state, action) => {
            state.deleteProposal = {
                ...state.deleteProposal,
                errors: action.payload,
                isDeleting: false,
            };
        },
        [DELETE_PROPOSAL_SUCCESS]: (state, action) => {
            state.deleteProposal = {
                ...state.deleteProposal,
                data: action.payload,
                isDeleting: false,
            };
        },
        [FETCH_PROPOSALS]: (state) => {
            state.proposals = {
                ...state.proposals,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_PROPOSALS_FAILURE]: (state, action) => {
            state.proposals = {
                ...state.proposals,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PROPOSALS_SUCCESS]: (state, action) => {
            state.proposals = {
                ...state.proposals,
                data: action.payload,
                isFetching: false,
            };
        },
        [OPEN_PROPOSAL_MODAL]: (state, action) => {
            state.isOpenProposalModal = action.payload;
        },
        [RESET]: () => INITIAL_STATE,
        [SHOW_EMPTY_STATE]: (state, action) => {
            state.showEmptyState = action.payload;
        },
    },
});

export const proposalsActions = proposalsSlice.actions;

export default proposalsSlice.reducer;
